import {Component, inject, OnInit} from '@angular/core';
import {CrossGameAdminViewFaqsComponent} from "./cross-game-admin-view-faqs/cross-game-admin-view-faqs.component";
import {GameAdminViewFaqsComponent} from "./game-admin-view-faqs/game-admin-view-faqs.component";
import {GameService} from "../../../services/game.service";

@Component({
  selector: 'app-view-frequently-asked-questions',
  standalone: true,
  imports: [
    CrossGameAdminViewFaqsComponent,
    GameAdminViewFaqsComponent
  ],
  templateUrl: './view-frequently-asked-questions.component.html',
  styleUrl: './view-frequently-asked-questions.component.css'
})
export class ViewFrequentlyAskedQuestionsComponent implements OnInit {

  public isCrossGameAdmin: boolean = false;

  private gameService = inject(GameService);

  ngOnInit() {
    this.isCrossGameAdmin = !this.gameService.activeGame()?.Id;
  }
}
